module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"startPlaceholder":"min","endPlaceholder":"max"},"et":{"startPlaceholder":"min","endPlaceholder":"max"},"ru":{"startPlaceholder":"min","endPlaceholder":"max"}}')
  delete Component.options._Ctor
}
